module.exports = __webpack_public_path__ + "static/media/boy_grining_smiling.56f9b3be.gif";